/* @flow */
import * as React from 'react';
import invariant from 'invariant';
import { once } from 'lodash';

import TextEntities from 'lib/TextEntities';
import Glyph from 'components/Glyph.jsx';
import Button from 'components/Button.jsx';
import Link from 'components/Link.jsx';
import Text from 'components/Text.jsx';
import Row from 'components/Row.jsx';
import ScrollWatch from 'components/ScrollWatch.jsx';
import TextWithEntities from 'components/TextWithEntities.jsx';
import { ChatSystemMessage } from 'entities/ChatMessage';
import EventTracking from 'lib/EventTracking';
import ModalTrigger from 'components/ModalTrigger.jsx';
import GroupMessageListModal from 'groups/components/GroupMessageListModal.jsx';

import cx from 'classnames';
import './styles/MessageSystemItem.scss';

function getModalForPath(url) {
  const urlParts = url.split('/');
  if (urlParts[3] === 'classes' && urlParts[5] === 'history') {
    return <GroupMessageListModal groupCode={urlParts[4]} />;
  }
  return null;
}

function renderSystemLink(text, rendered, data) {
  const { url } = data;
  const link = (
    <Link href={url} target="_blank">
      {rendered}
    </Link>
  );
  const modal = getModalForPath(url);
  if (modal) {
    return <ModalTrigger modal={modal}>{link}</ModalTrigger>;
  }
  return link;
}

class MessageSystemItem extends React.Component<{
  message: ChatSystemMessage,
}> {
  trackView = once(() => {
    EventTracking.trackKey('text_after_call.contact_card.view');
  });

  renderAttachment() {
    const attachment = this.props.message.getFile();

    invariant(attachment, 'render attachment called without an attachment');
    const contentType = attachment.getContentType();
    if (!contentType || !contentType.includes('text/vcard')) {
      return null;
    }

    return (
      <ScrollWatch onEnter={() => this.trackView()}>
        <div>
          <Button
            level="text"
            href={attachment.getUrls().cdn}
            download
            eventKey="text_after_call.contact_card.click">
            <div className="MessageSystemItem-attachment">
              <Row size="xsmall">
                <Glyph name="contact" color="caribbean" size="xxlarge" />
              </Row>
              <Text size="xsmall">{attachment.getName()}</Text>
            </div>
          </Button>
        </div>
      </ScrollWatch>
    );
  }
  renderMessageBody() {
    const { message } = this.props;
    const body = message.getBody();
    if (!body) {
      return null;
    }

    const entities = [].concat(
      TextEntities.parseEmoji(body),
      TextEntities.parseNewlines(body),
      TextEntities.parseLeadingWhitespace(body),
      TextEntities.parseUrls(body),
      TextEntities.parseAttributes(message.getBodyAttributes(), renderSystemLink)
    );

    return (
      <div className={cx({ 'MessageSystemItem-body': true })}>
        <TextWithEntities text={body} entities={entities} />
        {message.getFile() && this.renderAttachment()}
      </div>
    );
  }

  render() {
    return <div className="MessageSystemItem">{this.renderMessageBody()}</div>;
  }
}

export default MessageSystemItem;
